import { CircleCheckIcon } from "@/components/Icons/circle-check-icon";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";

type CreateEntrySuccessfulModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => void;
  resetAllEntryStore: () => void;
};
export const CreateEntrySuccessfulModal = ({
  open,
  setOpen,
  onConfirm,
  resetAllEntryStore,
}: CreateEntrySuccessfulModalProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden py-8 w-[350px] md:w-[450px] h-[357x] ring-0 ring-transparent">
        <DialogTitle className="text-black text-center font-Inter text-[20px] font-semibold leading-[30px] mx-auto">
          エントリーが完了しました！
        </DialogTitle>

        <div className="flex justify-center items-center">
          <CircleCheckIcon className="h-[58px] w-[58px] text-secondary" />
        </div>

        <div className="text-dark-gray text-center text-base mt-2">試合が始まるまで、ワクワクしながら楽しもう！</div>

        <div className="flex flex-col w-full items-center justify-center mt-4">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
            variant="default"
            onClick={onConfirm}
          >
            エントリーを追加する
          </Button>
          <Button
            className="text-base mt-3"
            variant="link"
            onClick={() => {
              resetAllEntryStore();
              navigate("/");
            }}
          >
            閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
